module.exports = __webpack_public_path__ + "img/1-8-4.45024553.png";